/* eslint-disable @typescript-eslint/no-explicit-any */
import { Duration, Instant } from 'js-joda';
import { oc } from 'ts-optchain';
import _ from 'lodash';

import { SharedAppConstants } from '@tock/shared-app-constants';
import { metrics } from 'utils/reporting';
import protos from 'utils/protos';

const { ReportQuery, ReportQueries } = protos;

const filterOnBusinessAndPatron = (patronId: number, businessId: number) => {
  return {
    operation: 'AND',
    valueSet: [
      {
        field: ReportQuery.Dimension.DINER_PATRON_ID,
        value: [patronId],
      },
      {
        field: ReportQuery.Dimension.DIMENSION_ID,
        value: [businessId],
      },
    ],
  };
};

export function getPatronWaitlistStats(patronId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/waitlist/business/patron/${patronId}`,
      type: SharedAppConstants.PATRON_WAITLIST_STATS_FETCH,
    },
  };
}

export function getPatronStats(patronId: number, businessId: number, options?: any): ApiAction {
  const query = [
    {
      reportName: 'patron-stats',
      dimension: [],
      metric: [
        metrics.AllBookings.metric,
        metrics.AllNoShows.metric,
        metrics.AllCancellations.metric,
        metrics.BookByEmail.metric,
        metrics.NightOfWalkIns.metric,
        metrics.ImportedWalkinCount.metric,
      ],
      filter: filterOnBusinessAndPatron(patronId, businessId),
      timeBuckets: {
        startInstantMs: 0,
        endInstantMs: Instant.now().plus(Duration.ofDays(2)).toEpochMilli(),
        bucket: 'ALL',

        // a hack. the intent is to fetch all data, so we choose
        // long-past and future times so that offsets due to time
        // zone shouldn't matter.
        timeZone: 'UTC',
      },
    },
  ];
  const requestProto = ReportQueries.fromObject({
    query,
  });
  return {
    TockApi: {
      postProto: '/admin/reporting',
      type: SharedAppConstants.PATRON_STATS_FETCH,
      request: requestProto,
      onError: '', // Ignore reporting errors.
      context: (oc(options) as any).context(),
    },
  };
}

export function getAllPatronStats(patronId: number, businessId: number, options?: any) {
  if (_.isNaN(patronId)) {
    window.LOGGER?.warn(`PatronId is NaN with businessId: ${businessId}`);
  }
  return (dispatch: Dispatch) => {
    dispatch(getPatronStats(patronId, businessId, options));
    dispatch(getPatronWaitlistStats(patronId));
  };
}
